import { useTranslation } from "react-i18next";
import defaultContent from "../../../../../content/downlineProfile";
import { IconAlertWhite } from "../../../../../common/icons/IconAlertWhite/IconAlertWhite";
import { getLongPeriodFormat } from "../../../../../common/util/period";
import { storedLocale } from "../../../../Authentication/util";
import { getSopSubscriptionSchedule, isSopSubscriptionUpForRenewal, type SopSubscription } from "../sopStatusData";
import { SopLegendIcon } from "../Shared/LegendIcon";
import "./SopCard.scss";

type Props = {
  subscription: SopSubscription;
};

export const SopCard = ({ subscription }: Props) => {
  const { t } = useTranslation("downlineProfile");
  const locale = storedLocale();
  const subscriptionSchedule = getSopSubscriptionSchedule(subscription, locale);
  const isUpForRenewal = isSopSubscriptionUpForRenewal(subscription);

  return (
    <div className="SopCard">
      <div className="SopCard__headerContainer">
        {isUpForRenewal && (
          <div className="SopCard__renewalTagSlot">
            <div className="SopCard__renewalTag">
              <IconAlertWhite /> {t("sopStatus.upForRenewal", defaultContent.sopStatus.upForRenewal)}
            </div>
          </div>
        )}
        <section className={`SopCard__header ${isUpForRenewal ? "SopCard__header--tagged" : ""}`}>
          {subscription.imgUrl && <img className="SopCard__productImage" src={subscription.imgUrl} alt="" />}
          <span className="SopCard__productName">{subscription.productName}</span>
        </section>
      </div>
      <section className="SopCard__subscriptionDetails">
        <div className="SopCard__subscriptionDetailRow">
          <span className="SopCard__subscriptionTitle">
            {t("sopStatus.startDate", defaultContent.sopStatus.startDate)}
          </span>
          <span className="SopCard__subscriptionValue">{getLongPeriodFormat(subscription.startDate, locale)}</span>
        </div>
        <div className="SopCard__subscriptionDetailRow">
          <span className="SopCard__subscriptionTitle">
            {t("sopStatus.expiryDate", defaultContent.sopStatus.expiryDate)}
          </span>
          <span className="SopCard__subscriptionValue">{getLongPeriodFormat(subscription.endDate, locale)}</span>
        </div>
        <div className="SopCard__subscriptionDetailRow">
          <span className="SopCard__subscriptionTitle">
            {t("sopStatus.monthlySopPv", defaultContent.sopStatus.monthlySopPv)}
          </span>
          <span className="SopCard__subscriptionValue">{subscription.productPV}</span>
        </div>
      </section>

      <section className="SopCard__frequencyDetails">
        <h3>{t("sopStatus.frequencySchedule", defaultContent.sopStatus.frequencySchedule)}</h3>
        <section className="SopCard__schedule">
          {subscriptionSchedule.map((s) => (
            <div
              key={s.month}
              className={`SopCard__scheduleMonthBlock ${s.isFuture ? `SopCard__scheduleMonthBlock--future` : ""}`}
            >
              <span className="SopCard__scheduleMonthBlock--month">{s.monthName}</span>
              <span className="SopCard__scheduleMonthBlock--qty">{s.qty}</span>
              <span className="SopCard__scheduleMonthBlock--tags">
                {s.isPromo && <SopLegendIcon type="promo" fullWidth />}
                {s.isExpiration && <SopLegendIcon type="expiry" fullWidth />}
              </span>
            </div>
          ))}
        </section>
      </section>
    </div>
  );
};
